export default __webpack_public_path__ + "static/media/kitchen2.6f4f13c0.jpg";